/**
 * 门店管理 · 门店列表（PRD：筛选、分页、新建/编辑、标签操作等；接口 URL 待对接）
 */
import { PageContext, uuid } from '@zto/zpage'
import {
  storeFormDialog,
  maintainTagsDialog,
  batchAppendTagsDialog,
  batchReplaceTagsDialog,
  logDialog
} from './_dialogs'
import dayjs from 'dayjs'
import { ElLoading, ElMessageBox } from 'element-plus'


const PAGE_COLUMNS = [
  { label: '门店编号', prop: 'shopCode', minWidth: 140 },
  { label: '渠道', prop: 'channelName', minWidth: 100 },
  {
    label: '省市区',
    prop: 'addressDetail',
    minWidth: 220,
    formatter: (row: any) => {
      return [row?.province || '', row?.city || '', row?.district || ''].filter(Boolean).join('-')
    }
  },
  { label: '详细地址', prop: 'detailAddress', minWidth: 180 },
  { label: '门店名称', prop: 'shopName', minWidth: 140 },
  { label: '联系人', prop: 'contactName', minWidth: 100 },
  { label: '电话', prop: 'contactPhone', minWidth: 120 },
  {
    label: '格口数',
    prop: 'gridCount',
    minWidth: 90,
    formatter: (row: any) => row.gridCount ?? '--'
  },
  {
    label: '日包裹量',
    prop: 'dailyParcelEstimate',
    minWidth: 100,
    formatter: (row: any) => row.dailyParcelEstimate ?? '--'
  },
  {
    label: '是否新门店',
    prop: 'isNewShop',
    minWidth: 110,
    formatter: (row: any) => (row.isNewShop === 1 ? '是' : '否')
  },
  {
    label: '标签',
    prop: 'tags',
    formatter: (row: any) => row.tags?.map((item: any) => item.tagName).join('、') || '--',
    minWidth: 160
  },
  {
    label: '创建时间',
    prop: 'gmtCreate',
    minWidth: 165,
    formatter: (row: any) => (row.gmtCreate ? dayjs(row.gmtCreate).format('YYYY-MM-DD HH:mm:ss') : '--')
  }
]



export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: '/cabinet/admin/base/AdminBaseShopQueryController/queryList'
      },
      add: {
        label: '新建门店',
        api: '/cabinet/admin/base/AdminBaseShopCommandController/add',
        dialog: storeFormDialog('add'),
        successMessage: '保存成功'
      },
      edit: {
        label: '编辑',
        api: '/cabinet/admin/base/AdminBaseShopCommandController/edit',
        dialog: storeFormDialog('edit'),
        successMessage: '保存成功'
      },
      view: {
        label: '详情',
        dialog: storeFormDialog('view')
      },
      maintainTags: {
        label: '维护标签',
        api: '/cabinet/admin/base/AdminBaseShopCommandController/updateTags',
        dialog: maintainTagsDialog,
        successMessage: '保存成功'
      },
      // 追加标签
      batchAppendTags: {
        label: '批量打标',
        api: '/cabinet/admin/base/AdminBaseShopCommandController/appendTags',
        message: false,
        dialog: batchAppendTagsDialog,
        successMessage: '保存成功',
        payload: async ({ app, data }: PageContext, ext: any) => {
          const { Message } = app.useMessage()
          const selectedRows = ext?.selection
          if (Array.isArray(selectedRows)) {
            // if (!app.getPageSearchData().isCheck) {
            //   Message.warning('请先按供应商进行筛选后再操作推送！')
            //   return false
            // }
            const len = selectedRows?.length
            if (!len) {
              Message.warning('请至少选择一条数据！')
              return false
            }
            const shopCodes = selectedRows.map((it: any) => it?.shopCode).filter(Boolean)
            return {
              shopCodes,
              tagCodes: data.tagCodes
            }
          }
        }
      },
      batchReplaceTags: {
        label: '批量编辑标签',
        api: '/cabinet/admin/base/AdminBaseShopCommandController/updateTags',
        message: false,
        dialog: batchReplaceTagsDialog,
        successMessage: '保存成功',
        payload: async ({ app, data }: PageContext, ext: any) => {
          const { Message } = app.useMessage()
          const selectedRows = ext?.selection
          if (Array.isArray(selectedRows)) {
            // if (!app.getPageSearchData().isCheck) {
            //   Message.warning('请先按供应商进行筛选后再操作推送！')
            //   return false
            // }
            const len = selectedRows?.length
            if (!len) {
              Message.warning('请至少选择一条数据！')
              return false
            }
            const shopCodes = selectedRows.map((it: any) => it?.shopCode).filter(Boolean)
            return {
              shopCodes,
              tagCodes: data.tagCodes
            }
          }
        }
      },
      import: {
        label: '批量导入',
        api: '/cabinet/admin/base/AdminBaseShopCommandController/import',
        apiParams: () => ({ batchNum: uuid() }),
        template: 'import_shop_list',
        dataProp: 'list',
        maxCount: 1000,
        showMessage: false,
        transformMethod: (data: any) => {
          console.info('🚀 ~ file:index method:transformMethod line:30 ----- data', data)
          return (data || []).map((item: any) => {
            const { provinceStr, cityStr, districtStr } = item
            const [province, provinceCode] = provinceStr?.split('-') || []
            const [city, cityCode] = cityStr?.split('-') || []
            const [district, districtCode] = districtStr?.split('-') || []
            return {
              ...item,
              province: province || '',
              provinceCode: provinceCode || '',
              city: city || '',
              cityCode: cityCode || '',
              district: district || '',
              districtCode: districtCode || ''
            }
          })
        },
        onSubmit: async (payload: any, { app, result }: any) => {
          try {
            // console.info('🚀 ~ file:index method:onSubmit line:40 ----- payload', app, result, payload)
            const { MessageBox, Message } = app.ui || {}
            const { totalCount, failCount, failedList } = result || {}
            if (totalCount > 0 && !failCount) {
              app.triggerPageSearch()
              Message.success(`数据导入成功`)
              return
            }
            await MessageBox.confirm(
              `成功导入${Math.max((totalCount || 0) - (failCount || 0), 0)}行数据，失败${
                failCount || 0
              }行数据，是否下载错误明细？`,
              '批量导入门店',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }
            )

            // 5. 获取列配置
            const columns = [
              { label: '门店编号', prop: 'shopCode' },
              { label: '门店名称', prop: 'shopName' },
              {
                label: '省',
                prop: 'province',
                formatter: (row: any) => {
                  return [row?.province || '', row?.provinceCode || ''].filter(Boolean).join('-')
                }
              },
              {
                label: '市',
                prop: 'city',
                formatter: (row: any) => {
                  return [row?.city || '', row?.cityCode || ''].filter(Boolean).join('-')
                }
              },
              {
                label: '区',
                prop: 'district',
                formatter: (row: any) => {
                  return [row?.district || '', row?.districtCode || ''].filter(Boolean).join('-')
                }
              },
              { label: '详细地址', prop: 'detailAddress', minWidth: 180 },
              { label: '联系人', prop: 'contactName', minWidth: 100 },
              { label: '电话', prop: 'contactPhone', minWidth: 120 },
              { label: '格口数', prop: 'gridCount', minWidth: 90 },
              { label: '日包裹量', prop: 'dailyParcelEstimate', minWidth: 100 },
              { label: '渠道', prop: 'channelCode', minWidth: 100 },
              { label: '失败原因', prop: 'failReason', minWidth: 100 }
            ]

            // 6. 格式化数据（应用 formatter）
            const formattedData = failedList.map((row: any) => {
              const formattedRow: any = {}
              columns.forEach((col: any) => {
                if (col.formatter) {
                  formattedRow[col.prop] = col.formatter(row)
                } else {
                  formattedRow[col.prop] = row[col.prop] || '--'
                }
              })
              return formattedRow
            })

            const exportDataFn = app.useComponentsConfig('xlsx.exportData')

            if (exportDataFn) {
              exportDataFn(formattedData, {
                columns: columns,
                fileName: '门店列表异常数据',
                app
              })
            }
            Message.success(`下载成功，共下载 ${formattedData.length} 条错误明细`)
            app.triggerPageSearch()
          } catch (error) {
            console.error('🚀 ~ file:index method:onSubmit line:100 ----- error', error)
          }
        },
        clearBeforeShow: true // 显示弹窗前清除文件
      },
      customExport: {
        label: '导出全部',
        customAction: true, // 重要：确保 onAction 被执行
        message: false, // 重要：不显示确认对话框，直接执行
        reload: false, // 导出成功后不重新请求列表接口
        payload: async (ctx: PageContext, ext: any) => {
          const raw = ext?.searchParams
          const pcd = raw?.pcd
          if (Array.isArray(pcd) && pcd[0]) {
            const p0 = pcd[0]
            raw.provinceCode = p0.provinceCode
            raw.cityCode = p0.cityCode
            raw.districtCode = p0.districtCode
          }
          delete raw.pcd
          return {
            ...raw
          }
        },
        onAction: async (ctx: PageContext, actionCfg: any) => {
          const { app } = ctx
          const { Message } = app.useMessage()

          // 显示全屏loading
          const loadingInstance = ElLoading.service({
            lock: true,
            text: '正在导出数据，请稍候...',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          try {
            const searchParams: any = ctx.data || {}

            const size = 1000 // 每页大小
            let current = 1 // 从第1页开始
            let lastId = null
            let allData: any[] = [] // 存储所有数据

            try {
              const res: any = await app.request({
                url: '/cabinet/admin/base/AdminBaseShopCommandController/export',
                data: {
                  ...searchParams
                }
              })

              allData = res || []

              // 更新提示信息
              // Message.info(`已查询 ${allData.length} 条数据，继续查询第 ${current} 页...`)
            } catch (pageError: any) {
              // 如果查询出错，停止查询
              console.error(`查询第 ${current} 页时出错:`, pageError)
              // 如果已经有数据，继续导出；如果没有数据，提示错误
              if (allData.length === 0) {
                throw pageError
              }
            }

            // 4. 检查是否有数据可导出
            if (!allData || allData.length === 0) {
              Message.warning('没有可导出的数据')
              return
            }

            // Message.info(`共查询到 ${allData.length} 条数据，正在准备导出...`)

            // 5. 获取列配置
            const columns = PAGE_COLUMNS

            // 6. 格式化数据（应用 formatter）
            const formattedData = allData.map((row: any) => {
              const formattedRow: any = {}
              columns.forEach((col: any) => {
                if (col.formatter) {
                  formattedRow[col.prop] = col.formatter(row)
                } else {
                  formattedRow[col.prop] = row[col.prop] || '--'
                }
              })
              return formattedRow
            })

            const exportDataFn = app.useComponentsConfig('xlsx.exportData')

            if (exportDataFn) {
              exportDataFn(formattedData, {
                columns: columns,
                fileName: '门店列表',
                app
              })
            }
            Message.success(`导出成功，共导出 ${formattedData.length} 条数据`)
          } catch (error: any) {
            console.error('导出失败:', error)
            // Message.error(error?.message || '导出失败，请稍后重试')
          } finally {
            // 关闭全屏loading
            loadingInstance.close()
          }
        }
      },
      log: {
        label: '导出记录',
        dialog: logDialog
      }
    },
    search: {
      labelWidth: 100,
      onReset: (searchParams: any) => {
        searchParams.tagCodes = []
      },
      beforeSearch: ({ searchParams }: PageContext) => {
        const raw = searchParams as Record<string, any>
        const pcd = raw?.pcd
        if (Array.isArray(pcd) && pcd[0]) {
          const p0 = pcd[0]
          raw.provinceCode = p0.provinceCode
          raw.cityCode = p0.cityCode
          raw.districtCode = p0.districtCode
        }
        delete raw.pcd
      },
      items: [
        {
          label: '所在地区',
          type: 'area-pro',
          prop: 'pcd',
          allowPartial: true,
          keyConfig: {
            provinceCode: 'provinceCode',
            province: 'province',
            cityCode: 'cityCode',
            city: 'city',
            districtCode: 'districtCode',
            district: 'district'
          },
          filterable: true,
          span: 8
        },
        { type: 'input', prop: 'shopCode', label: '门店编号', span: 8 },
        { type: 'input', prop: 'shopName', label: '门店名称', span: 8 },
        {
          type: 'fuzzy-select',
          prop: 'tagCodes',
          label: '门店标签',
          optionValueProp: 'tagCode',
          optionLabelProp: 'tagName',
          triggerFocus: true,
          multiple: true,
          multipleLimit: 20,
          remote: true,
          autoHeight: true,
          collapseTags: false,
          keywordProp: 'tagName',
          api: '/cabinet/admin/base/AdminBaseShopTagQueryController/page',
          span: 16
        }
      ]
    },
    toolbar: {
      noExport: true,
      items: [
        { action: 'add' },
        { action: 'import' },
        { action: 'customExport' },
        { action: 'batchAppendTags' },
        { action: 'batchReplaceTags' },
        { action: 'log' }
      ]
    },
    table: {
      showCheckbox: true,
      operation: {
        width: 220,
        items: [{ action: 'view' }, { action: 'edit' }, { action: 'maintainTags' }]
      },
      columns: PAGE_COLUMNS
    }
  }
}
